import { FC } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  SxProps,
  Card,
  CardContent,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { lightTheme } from "../../theme";
import CompareArrowsOutlinedIcon from "@mui/icons-material/CompareArrowsOutlined";

const moduleCardStyles: SxProps<typeof lightTheme> = {
  height: "100%",
  display: "flex",
  flexDirection: "column",
  transition: "box-shadow 0.3s ease-in-out",
  "&:hover": {
    boxShadow: "0 4px 16px rgba(0,0,0,0.52)",
  },
};

export const Home: FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        padding: 4,
        maxWidth: 1200,
        margin: "0 auto",
      }}
    >
      <Box sx={{ marginBottom: 4 }}>
        <Typography
          variant="h4"
          component="h1"
          color="text.primary"
          sx={{
            fontWeight: 600,
            marginBottom: 1,
          }}
        >
          Compliance Hub
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Centralized landing page for Compliance Hub modules. Trade Matcher is
          the first feature route and the next area to implement.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Card elevation={7} sx={moduleCardStyles}>
            <CardContent sx={{ padding: 3, flexGrow: 1 }}>
              <Box
                sx={{ display: "flex", alignItems: "center", marginBottom: 2 }}
              >
                <CompareArrowsOutlinedIcon
                  sx={{
                    fontSize: 24,
                    color: "text.primary",
                    marginRight: 1.5,
                  }}
                />
                <Typography
                  variant="h6"
                  component="span"
                  color="text.primary"
                  sx={{ fontWeight: 600 }}
                >
                  Trade Matcher
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary">
                Ensure that trades can be matched to ABN
              </Typography>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => navigate("/tradematcher")}
                sx={{
                  marginTop: 2,
                  borderColor: "text.primary",
                  color: "text.primary",
                  "&:hover": {
                    backgroundColor: "text.primary",
                    color: "white",
                  },
                }}
              >
                Go to module
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};
